module.exports = __webpack_public_path__ + "img/logo.7cfe4eec.png";